import { Injectable, Injector } from '@angular/core';
import { remove } from 'lodash';
import { ObservablesService } from '../../Services/observables/observables';

@Injectable()
export class ComponentDimensions {
  //heights: any;
  //listeners: any;

  //constructor(private observablesService: ObservablesService) {
  //  this.heights = {};
  //  this.listeners = {};
  //}

  //getHeight(key) {
  //  console.log(this.heights, this.listeners);
  //  return this.heights[key];
  //}

  //setHeight(key, value) {
  //  this.heights[key] = value;
  //  this.fireEvents(key);
  //}

  //on(key, callback) {
  //  if (this.listeners[key]) {
  //    this.listeners[key].push(callback);
  //  }
  //  else {
  //    this.listeners[key] = [callback];
  //  }

  //  this.observablesService.setheaderTop.next();
  //}

  //off(key, callback) {
  //  remove(this.listeners[key], (handler) => handler === callback);
  //}

  //fireEvents(key) {
  //  const listeners = this.listeners[key]; // [callback]

  //  if (listeners) {
  //    listeners.forEach((callback) => callback());
  //  }
  //}
}

